import Transmitter2 from "../components/Transmitter2";
import Transmitter from "../components/Transmitter";
import "./NK2Wellhead.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect, useContext } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import Valve from "../components/Valve";

import { trackPageVisit } from "../competency/PageTracker";




    /* 🔥 TEMPERATURE TRANSMITTER */
    function TemperatureTransmitterOutput({ value, x, y, unit }) {
      const temp = Number(value) || 0;

      let statusClass;

      if (temp < 49) {
        statusClass = "alarm";
      } else if (temp >= 50 && temp <= 99) {
        statusClass = "warning";
      } else if (temp >= 100 && temp <= 280) {
        statusClass = "normal";
      } else if (temp >= 281) {
        statusClass = "alarm";
      } else {
        statusClass = "normal"; // fallback safety
      }

      return (
        <div
          className={`temperature-transmitter-output ${statusClass}`}
          style={{ position: "absolute", left: x, top: y }}
        >
          {temp.toFixed(3)} {unit}
        </div>
      );
    }

    /* 🔥 PRESSURE TRANSMITTER */
    function PressureTransmitterOutput({ value, x, y, unit }) {
      const pressure = Number(value) || 0;

      let statusClass;

      if (pressure < 10) {
        statusClass = "alarm";
      } else if (pressure >= 10 && pressure <= 19) {
        statusClass = "warning";
      } else if (pressure >= 20 && pressure <= 100) {
        statusClass = "normal";
      } else if (pressure >= 101 && pressure <= 149) {
        statusClass = "warning";
      } else if (pressure >= 150) {
        statusClass = "alarm";
      } else {
        statusClass = "normal"; // fallback safety
      }

      return (
        <div
          className={`pressure-transmitter-output ${statusClass}`}
          style={{ position: "absolute", left: x, top: y }}
        >
          {pressure.toFixed(3)} {unit}
        </div>
      );
    }


    
    /* ✅ Reusable Indicator */
    function Indicator({ x, y, isClosed }) {
      return (
        <svg width="80" height="80" style={{ position: "absolute", left: x, top: y }}>
          <circle
            cx="40"
            cy="30"
            r="17"
            fill={isClosed ? "red" : "lime"}
            stroke="black"
            strokeWidth="2"
          />
        </svg>
      );
    }





      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


              
          






function NK2Wellhead() {

        useEffect(() => {
  
    trackPageVisit("NK2Wellhead");
  
  }, []);

        

  const [valveData, setValveData] = useState(() => {
      const saved = localStorage.getItem("nk2_valveData");
      return saved
        ? JSON.parse(saved)
        : {
            FCV_10201: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10202: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10203: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10204: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10205: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10206: { mode: "Manual", opening: 0, sp: "", pv: "" },
            CHK_102: { mode: "Manual", opening: 0, sp: "", pv: "" }
          };
        });

        const { valves, toggleValve } = useContext(WellContext);


        useEffect(() => {
            localStorage.setItem("nk2_valveData", JSON.stringify(valveData));
          }, [valveData]);
  

          const { getPT10203, getTT10201 } = useContext(WellContext);

          

        const [FIC_10809, setFIC_10809] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_10809")) || 0;
            setFIC_10809(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

        const [PT_10809, setPT_10809] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_10809")) || 0;
            setPT_10809(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);




        const isGLV6Open = valves.GLV_6 === false;
        const isGLV7Open = valves.GLV_7 === false;
        const isGLV8Open = valves.GLV_8 === false;
        const isGLV9Open = valves.GLV_9 === false;



        const isOpen = (tag) => !valves[tag]; // IMPORTANT: normalize logic             
                const xv10208Open = isOpen("XV_10208");

                const fcvOpening = Number(valveData.FCV_10202?.opening ?? 0);
                const fcvFactor = fcvOpening / 100;

                let fic10200 = 0;
                let pt10207 = 0;

                if (xv10208Open) {
                  fic10200 = fcvFactor * 12;
                  pt10207 = fcvFactor * 10;
                } else {
                  fic10200 = 0;
                  pt10207 = 0.003;
                }

                // ===============================
                // CONTROL: FCV-10203 → FIC-10202 & PT-10208
                // ===============================

                const fcv10203Opening = Number(valveData.FCV_10203?.opening ?? 0);
                const fcv10203Factor = fcv10203Opening / 100;

                // optional: if you want XV interlock (recommended for realism)
                const xv10201Open = isOpen("XV_10201");

                let fic10202 = 0;
                let pt10208 = 0;

                if (xv10201Open) {
                  // Flow through FCV-10201
                  fic10202 = fcv10203Factor * 15;   // <-- scaling factor (adjust as needed)
                  pt10208 = fcv10203Factor * 12;    // <-- pressure response
                } else {
                  fic10202 = 0;
                  pt10208 = 0.003; // shutdown leakage / dead pressure
                }


                  // ===========================================================
                // CONTROL: FCV-10201 → FIC-10201 & PT-10209 (GAS LIFT LINE)
                // =============================================================

                const fcv10201Opening = Number(valveData.FCV_10201?.opening ?? 0);
                const fcv10201Factor = fcv10201Opening / 100;

                // optional: if you want XV interlock (recommended for realism)
                const xv10209Open = isOpen("XV_10209");

                let fic10201 = 0;
                let pt10209 = 0;

                if (xv10209Open) {
                  // Flow through FCV-10201
                  fic10201 = fcv10201Factor * FIC_10809;   // <-- scaling factor (adjust as needed)
                  pt10209 = fcv10201Factor * PT_10809;    // <-- pressure response
                } else {
                  fic10201 = 0;
                  pt10209 = 0.003; // shutdown leakage / dead pressure
                }




        const FIC_101056 = isGLV6Open ? fic10201 * 0.05 : 0;
        const PT_101056 = isGLV6Open ? pt10209 * 0.05 : 0;

                
        const FIC_101057 = isGLV7Open ? fic10201 * 0.09 : 0;
        const PT_101057 = isGLV7Open ? pt10209 * 0.08 : 0;

        const FIC_101058 = isGLV8Open ? fic10201 * 0.11 : 0;
        const PT_101058 = isGLV8Open ? pt10209 * 0.11 : 0;

        const FIC_101059 = isGLV9Open ? fic10201 * 0.13 : 0;
        const PT_101059 = isGLV9Open ? pt10209 * 0.13 : 0;



        const tt10201Value = getTT10201("NK2");
          const pt10203Value = getPT10203("NK2");
          const pt10204Value = PT_101058 + PT_101059 + pt10203Value * 0.915;
          const pt102013Value = PT_101057 + pt10204Value * 0.386;
         
          const [tt10202Value, setTT10202Value] = useState(() => {
          return Number(localStorage.getItem("TT_10202")) || 0;
        });

        useEffect(() => {
          const interval = setInterval(() => {
            setTT10202Value(prev => {
              const target = tt10201Value * 0.88;
              const diff = target - prev;

              const step = diff * 0.05; // slower (thermal lag)

              if (Math.abs(diff) < 0.001) return target;

              return prev + step;
            });
          }, 200);

          return () => clearInterval(interval);
        }, [tt10201Value]);

        useEffect(() => {
          localStorage.setItem("TT_10202", tt10202Value);
        }, [tt10202Value]);


         
         
         
          const tt10205Value = tt10202Value * 0.90;
          const pt10205Value = PT_101056 + pt102013Value * 0.73;

        const isSSSVClosed = valves.SSSV_10202;
        const isDHSVClosed = valves.DHSV_10201;
        const isWellShut = isSSSVClosed || isDHSVClosed;

          const chkOpening = Number(valveData.CHK_102?.opening) || 0;

          const chkFactor = chkOpening / 100;

         
          


          const pt10206Target = isWellShut
            ? 0.003
            : pt10205Value * (chkOpening / 100);

          const tt10206Target = isWellShut
            ? 0.003
            : tt10205Value * (chkOpening / 100);




         
           const { wellData } = useContext(WellContext);

          const nk2Data = wellData?.NK2 || {};


          
          const oilPercent =
            (nk2Data.percentages?.["C5+ liquid hydrocarbons (oil)"] || 0) +
            (nk2Data.percentages?.["Pentanes+ (C5+)"] || 0) +
            (nk2Data.percentages?.["Wax / paraffins"] || 0) +
            (nk2Data.percentages?.["Asphaltenes"] || 0);

          const gasPercent =
            (nk2Data.percentages?.["Dissolved light hydrocarbons C1–C4"] || 0) +
            (nk2Data.percentages?.["Methane (CH4)"] || 0) +
            (nk2Data.percentages?.["Ethane (C2H6)"] || 0) +
            (nk2Data.percentages?.["Propane (C3H8)"] || 0) +
            (nk2Data.percentages?.["Butanes (i-C4 / n-C4)"] || 0);

          const impPercent =
            (nk2Data.percentages?.["Carbon dioxide (CO2)"] || 0) +
            (nk2Data.percentages?.["Nitrogen (N2)"] || 0) +
            (nk2Data.percentages?.["Hydrogen sulfide (H2S)"] || 0) +
            (nk2Data.percentages?.["Formation water (H2O)"] || 0) +
            (nk2Data.percentages?.["Dissolved salts"] || 0) +
            (nk2Data.percentages?.["Sand"] || 0) +
            (nk2Data.percentages?.["Organic acids"] || 0) +
            (nk2Data.percentages?.["Trace metals"] || 0) +
            (nk2Data.percentages?.["Scale-forming ions"] || 0);


            const totalPercent = oilPercent + gasPercent + impPercent || 1;
            

            const totalRate = Number(nk2Data.productionRateInput) || 0;

            const oilBase = totalRate * (oilPercent / totalPercent);
            const gasBase = totalRate * (gasPercent / totalPercent);
            const impBase = totalRate * (impPercent / totalPercent);

            // 🔥 Apply CHK + SSSV logic
            const oilRate = isWellShut ? 0 : FIC_101056 + FIC_101057 + FIC_101058 + FIC_101059 + oilBase * chkFactor;
            const gasRate = isWellShut ? 0 : FIC_101056 + FIC_101057 + FIC_101058 + FIC_101059 + gasBase * chkFactor;
            const impRate = isWellShut ? 0 : FIC_101056 + FIC_101057 + FIC_101058 + FIC_101059 + impBase * chkFactor;


            
            const [fiqNK2, setFiqNK2] = useState(() => {
                return Number(localStorage.getItem("fiqNK2")) || 0;
              }); 

            useEffect(() => {
                const interval = setInterval(() => {

                  // 🔹 Get values
                  const totalRate = Number(nk2Data.productionRateInput) || 0;
                  const chkOpening = Number(valveData.CHK_102?.opening) || 0;
                  const chkFactor = chkOpening / 100;

                  // 🔹 Increment per second
                  const increment = totalRate * chkFactor;

                  // 🔹 Only accumulate if SSSV is OPEN
                  if (!valves.SSSV_10202) {
                    setFiqNK2(prev => prev + increment);
                  }

                }, 1000);

                return () => clearInterval(interval);

              }, [nk2Data.productionRateInput, valveData.CHK_102, valves.SSSV_10202]);

              const resetFIQ = () => {
                  setFiqNK2(0);
                };

                useEffect(() => {
            localStorage.setItem("fiqNK2", fiqNK2);
          }, [fiqNK2]);

                

                const totalFlow = oilRate + gasRate + impRate;

                const isXV10204Open = !valves.XV_10204; // assuming red = closed, lime = open
                const isXV10203Open = !valves.XV_10203;

                let fic10204 = 0;
                let fic10203 = 0; 

                if (isXV10204Open && !isXV10203Open) {
                  // Only 10204 open
                  fic10204 = totalFlow;
                  fic10203 = 0;

                } else if (!isXV10204Open && isXV10203Open) {
                  // Only 10203 open
                  fic10204 = 0;
                  fic10203 = totalFlow;

                } else if (isXV10204Open && isXV10203Open) {
                  // Both open → split
                  fic10204 = totalFlow / 2;
                  fic10203 = totalFlow / 2;

                } else {
                  // Both closed
                  fic10204 = 0;
                  fic10203 = 0;
                }

                if (valves.SSSV_10202) {
                  fic10204 = 0;
                  fic10203 = 0;
                }



                  useEffect(() => {
                      localStorage.setItem("fic10203", fic10203);
                    }, [fic10203]);

                  useEffect(() => {
                      localStorage.setItem("fic10204", fic10204);
                    }, [fic10204]);


                


                const xv10205Open = isOpen("XV_10205");

                let fic10209 = 0;
                let pt10201 = 0;

                if (xv10205Open) {
                  // Flow through FCV-10201
                  fic10209 = 15;   // <-- scaling factor (adjust as needed)
                  pt10201 = 12.67;    // <-- pressure response
                } else {
                  fic10209 = 0;
                  pt10201 = 0.003; // shutdown leakage / dead pressure
                }



       
   
         const updateValveData = (tag, field, value) => {
        setValveData(prev => {
          const updated = {
            ...prev,
            [tag]: {
              ...prev[tag],
              [field]: value
            }
          };

          // 🔥 Save CHK opening globally
          if (tag === "CHK_102" && field === "opening") {
            localStorage.setItem("CHK_102_opening", value);
          }

          return updated;
        });
      };
        


        

        
    const [openPanels, setOpenPanels] = useState([]);

    const openPanel = (tag) => {
        if (!openPanels.includes(tag)) {
          setOpenPanels(prev => [...prev, tag]);
        }
      };

      const closePanel = (tag) => {
        setOpenPanels(prev => prev.filter(p => p !== tag));
      };




        /* 🔥 ALARM ENGINE TAGS */

        const { evaluateTag } = useContext(AlarmContext);

        useEffect(() => {
          evaluateTag("TT_10201", tt10201Value);
          evaluateTag("FIC_10200", fic10200);
          evaluateTag("FIC_10202", fic10202);
          evaluateTag("CHK_102", valveData.CHK_102.opening);


        }, [tt10201Value, fic10200, fic10202, valveData.CHK_102.opening]);

       
        const { updateWellSignals } = useContext(WellContext);
                useEffect(() => {
                  updateWellSignals("NK2", {
                    fic: fic10204,
                    pt: pt10206Target,
                    tt: tt10206Target,
                    fic2: fic10203,
                    pt2: pt10206Target,
                    oil: oilRate,
                    gas: gasRate,
                    water: impRate                  });
                }, [fic10204], [pt10206Target], [fic10203], [pt10206Target], [oilRate], [gasRate], [impRate], [tt10206Target]
              
              );

  return (
    <div className="nk2-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "-16px",
        left: "280px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "4px 265px"
      }}>
        NK-2 WELLHEAD
      </h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "30px",
        left: "123px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10206
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "73px", left: "160px", color: "white", fontSize: "10px"}}>%</h2>
        

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "89px",
        left: "123px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10205
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "131px", left: "160px", color: "white", fontSize: "10px"}}>%</h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "155px",
        left: "160px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10204
      </h2>

       {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "205px", left: "190px", color: "white", fontSize: "10px"}}>%</h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "220px",
        left: "115px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10206
      </h2>

        {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "458px", left: "190px", color: "white", fontSize: "10px"}}>%</h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "293px",
        left: "168px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10205
      </h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "398px",
        left: "155px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10201
      </h2>

       {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "225px",
        left: "285px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10207
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "229px",
        left: "485px",
        color: "black",
        fontSize: "10px"
      }}>
        SSSV-10202
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "576px",
        left: "475px",
        color: "black",
        fontSize: "10px"
      }}>
        DHSV-10201
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "89px",
        left: "725px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10203
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "150px", left: "759px", color: "white", fontSize: "10px"}}>%</h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "433px",
        left: "905px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10202
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "492px", left: "940px", color: "white", fontSize: "10px"}}>%</h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "445px",
        left: "1070px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10208
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "370px",
        left: "1092px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10203
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "270px",
        left: "1110px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10204
      </h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "337px",
        left: "285px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10209
      </h2>

      {/* ================= WHCP INDICATOR TAGS ================= */}

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "95px",
        left: "1020px",
        color: "black",
        fontSize: "10px"
      }}>
        DHSV-10201
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "144px",
        left: "1020px",
        color: "black",
        fontSize: "10px"
      }}>
        SSSV-10202
      </h2>

       {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "189px",
        left: "1020px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10204
      </h2>

       {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "233px",
        left: "1020px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10203
      </h2>

        {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "95px",
        left: "1157px",
        color: "black",
        fontSize: "10px"
      }}>
        GLV-6
      </h2>

       {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "143px",
        left: "1157px",
        color: "black",
        fontSize: "10px"
      }}>
        GLV-7
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "189px",
        left: "1157px",
        color: "black",
        fontSize: "10px"
      }}>
        GLV-8
      </h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "233px",
        left: "1157px",
        color: "black",
        fontSize: "10px"
      }}>
        GLV-9
      </h2>


      {/* ================= TRANSMITTERS TAGS AND UNITS ================= */}
      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "293px",
        left: "255px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10210
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "293px",
        left: "330px",
        color: "black",
        fontSize: "10px"
      }}>
        FIC-10209
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "404px",
        left: "225px",
        color: "black",
        fontSize: "10px"
      }}>
        FIC-10201
      </h2>



      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "300px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10209
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "174px",
        left: "420px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10205
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "214px",
        left: "590px",
        color: "black",
        fontSize: "10px"
      }}>
        CHK_102
      </h2>

            {/* SI unit */}
      <h2 style={{position: "absolute", top: "225px", left: "619px", color: "white", fontSize: "9px"}}>%</h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "92px",
        left: "539px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10208
      </h2>


 {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "92px",
        left: "629px",
        color: "black",
        fontSize: "10px"
      }}>
        FIC-10202
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "292px",
        left: "676px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10206
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "282px",
        left: "760px",
        color: "black",
        fontSize: "10px",
        background:"blue",
      }}>
        MPFT-10200
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "284px",
        left: "976px",
        color: "black",
        fontSize: "10px",
      }}>
        FIC-10204
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "375px",
        left: "976px",
        color: "black",
        fontSize: "10px",
      }}>
        FIC-10205
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "375px",
        left: "836px",
        color: "black",
        fontSize: "10px",
      }}>
        FIQ-10201
      </h2>


            {/* SI unit */}
      <h2 className="RESET_FIQ_10101" style={{position: "absolute", top: "382px", left: "898px", color: "white", fontSize: "10px"}}>RESET</h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "493px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-102013
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "573px",
        color: "black",
        fontSize: "10px"
      }}>
        TT-10201
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "705px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10207
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "810px",
        color: "black",
        fontSize: "10px"
      }}>
        FIC-10200
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "511px",
        left: "510px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10204
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "511px",
        left: "330px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10202
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "618px",
        left: "330px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10201
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "618px",
        left: "509px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10203
      </h2>


       {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "618px",
        left: "584px",
        color: "black",
        fontSize: "10px"
      }}>
        TT-10201
      </h2>




      {/* ================= LINE AND PAGE CONNECTOR TAGS ================= */}

      <h2 style={{position: "absolute", top: "155px", left: "839px", color: "black", fontSize: "9px"}}>FROM CORROSION <br />INHIBITOR MANIFOLD</h2>

      <h2 style={{position: "absolute", top: "300px", left: "1239px", color: "white", fontSize: "9px"}}>TO TEST <br />HEADER</h2>

      <h2 style={{position: "absolute", top: "400px", left: "1219px", color: "white", fontSize: "9px"}}>TO PRODUCTION <br />HEADER</h2>

      <h2 style={{position: "absolute", top: "500px", left: "1209px", color: "black", fontSize: "9px"}}>FROM METHANOL <br />SUPPLY MANIFOLD</h2>

      <h2 style={{position: "absolute", top: "465px", left: "46px", color: "black", fontSize: "9px"}}>FROM GAS LIFT <br /> MANIFOLD</h2>

      <h2 style={{position: "absolute", top: "347px", left: "46px", color: "black", fontSize: "9px"}}>FROM ASPHALTHENE <br /> INHIBITOR MANIFOLD</h2>

      <h2 style={{position: "absolute", top: "269px", left: "42px", color: "black", fontSize: "9px"}}>KILL FLUID</h2>

      <h2 style={{position: "absolute", top: "205px", left: "42px", color: "black", fontSize: "9px"}}>FRESH WATER</h2>

      <h2 style={{position: "absolute", top: "137px", left: "42px", color: "black", fontSize: "9px"}}>COMPLETION <br />BRIME</h2>

      <h2 style={{position: "absolute", top: "80px", left: "42px", color: "black", fontSize: "9px"}}>NITROGEN</h2>




      {/* ================= CONTROL VALVES SVG ================= */}

        {/* FCV-10201 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10201"
          style={{ position: "absolute", left: 140, top: 423 }}  onClick={() => openPanel("FCV_10201")}>
          
          <defs>
            <linearGradient id="metal_10201">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10201)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10201)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        {/* FCV-10202 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10202"
          style={{ position: "absolute", left: 890, top: 455 }} onClick={() => openPanel("FCV_10202")}>
          
          <defs>
            <linearGradient id="metal_10202">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10202)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10202)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10203 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10203"
          style={{ position: "absolute", left: 709, top: 114 }} onClick={() => openPanel("FCV_10203")}>
          
          <defs>
            <linearGradient id="metal_10203">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10203)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10203)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10204 */}
        <svg width="80" height="40" viewBox="0 0 200 220" className="FCV-10204"
          style={{ position: "absolute", left: 140, top: 174 }} onClick={() => openPanel("FCV_10204")}>
          
          <defs>
            <linearGradient id="metal_10204">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10204)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10204)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10205 */}
        <svg width="80" height="40" viewBox="0 0 200 220" className="FCV-10205"
          style={{ position: "absolute", left: 108, top: 107 }} onClick={() => openPanel("FCV_10205")}>
          
          <defs>
            <linearGradient id="metal_10205">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10205)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10205)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10206 */}
        <svg width="80" height="40" viewBox="0 0 200 220" className="FCV-10206"
          style={{ position: "absolute", left: 108, top: 48 }} onClick={() => openPanel("FCV_10206")}>
          
          <defs>
            <linearGradient id="metal_10206">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10206)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10206)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>

        <svg
            className="CHK-102"
            width="80"
            height="55"
            viewBox="0 0 220 260"
            style={{ position: "absolute", left: 549, top: 245 }}
            onClick={() => openPanel("CHK_102")}
          >

          {/* Top Thin White Accents */}
          <line x1="50" y1="60" x2="200" y2="100" stroke="blue" strokeWidth="12" />
          <line x1="320" y1="60" x2="200" y2="100" stroke="blue" strokeWidth="12" />
          <rect x="50" y="20" width="5" height="30" fill="blue" strokeWidth="12"/>
          
          
          {/* Red Geometric Body Parts */}
          <g fill="#cc0000" stroke="#777" strokeWidth="1">
            {/* Top cap */}
            <rect x="150" y="115" width="100" height="45" />
            
            {/* Upper section */}
            <rect x="110" y="160" width="180" height="55" />
            
            {/* Middle section with notch details */}
            <rect x="110" y="225" width="180" height="100" />
            <rect x="140" y="215" width="20" height="15" />
            <rect x="190" y="215" width="20" height="15" />
            <rect x="240" y="215" width="20" height="15" />
            
            {/* Tapered transition */}
            <polygon points="110,325 290,325 260,370 140,370" />
            
            {/* Lower neck */}
            <rect x="140" y="370" width="120" height="40" />
            
            {/* Base steps */}
            <rect x="130" y="420" width="140" height="25" />
            <rect x="130" y="450" width="140" height="20" />

          </g>
        </svg>

        {/* ✅ MULTIPLE FACEPLATES - RENDER THE CONTROL PANEL */}
        {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData[tag] || { mode: "Manual", opening: 0, sp: "", pv: "" }}
              update={updateValveData} // ✅ FOR EDITING
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput 
        value={valveData.CHK_102.opening}
        x={590}
        y={230}
      />

      <ValveOutput
        value={valveData.FCV_10201.opening}
        x={165}
        y={464}
      />

      <ValveOutput
        value={valveData.FCV_10202.opening}
        x={913}
        y={498}
      />

      <ValveOutput
        value={valveData.FCV_10203.opening}
        x={733}
        y={156}
      />

      <ValveOutput
        value={valveData.FCV_10204.opening}
        x={165}
        y={211}
      />

      <ValveOutput
        value={valveData.FCV_10205.opening}
        x={135}
        y={137}
      />

      <ValveOutput
        value={valveData.FCV_10206.opening}
        x={135}
        y={79}
      />



           {/* =================SHUTDOWN VALVES + INDICATORS ================= */}

      {/* SSSV-10202 */}
      <Valve
        tag="SSSV_10202"
        x={500}
        y={250}
        isClosed={valves.SSSV_10202}
        toggle={toggleValve}
        className="SSSV-10202"
      />
      <Indicator
        x={950}
        y={125}
        isClosed={valves.SSSV_10202}
      />

      {/* XV-10104 */}
      <Valve
        tag="XV_10204"
        x={1115}
        y={290}
        isClosed={valves.XV_10204}
        toggle={toggleValve}
        className="XV-10204"
      />
      <Indicator
        x={950}
        y={170}
        isClosed={valves.XV_10204}
      />

      {/* XV-10203 */}
      <Valve
        className="XV-10203"
        tag="XV_10203"
        x={1100}
        y={393}
        isClosed={valves.XV_10203}
        toggle={toggleValve}
      />
      <Indicator
        x={950}
        y={215}
        isClosed={valves.XV_10203}
      />

      {/* DHSV-10201 */}
      <Valve
        tag="DHSV_10201"
        x={433}
        y={570}
        r={90}
        isClosed={valves.DHSV_10201}
        toggle={toggleValve}
        className="DHSV-10201"
      />
      <Indicator
        x={950}
        y={80}
        isClosed={valves.DHSV_10201}
      />

      {/* XV-10201 */}
      <Valve
        tag="XV_10201"
        x={530}
        y={160}
        r={90}
        isClosed={valves.XV_10201}
        toggle={toggleValve}
        className="XV-10201"
      />

      {/* XV-10205 */}
      <Valve
        tag="XV_10205"
        x={176}
        y={317}
        isClosed={valves.XV_10205}
        toggle={toggleValve}
        className="XV-10205"
      />

      {/* XV-10206 */}
      <Valve
        tag="XV_10206"
        x={120}
        y={238}
        isClosed={valves.XV_10206}
        toggle={toggleValve}
      />

      {/* XV-10207 */}
      <Valve
        tag="XV_10207"
        x={287}
        y={249}
        isClosed={valves.XV_10207}
        toggle={toggleValve}
        className="XV-10207"
      />

      {/* XV-10208 */}
      <Valve
        tag="XV_10208"
        x={1075}
        y={465}
        isClosed={valves.XV_10208}
        toggle={toggleValve}
        className="XV-10208"
      />


      {/* XV-10209 */}
      <Valve
        tag="XV_10209"
        x={290}
        y={355}
        isClosed={valves.XV_10209}
        toggle={toggleValve}
        className="XV-10209"
      />

      {/* GLV-6 */}
      <Valve
        tag="GLV_6"
        x={416}
        y={469}
        r={270}
        scale={0.7}
        isClosed={valves.GLV_6}
        toggle={toggleValve}
        className="GLV-6"
      />
      <Indicator
        x={1085}
        y={80}
        isClosed={valves.GLV_6}
      />


      {/* GLV-7 */}
      <Valve
        tag="GLV_7"
        x={416}
        y={522}
        r={270}
        scale={0.7}
        isClosed={valves.GLV_7}
        toggle={toggleValve}
        className="GLV-7"
      />
      <Indicator
        x={1085}
        y={126}
        isClosed={valves.GLV_7}
      />


      {/* GLV-8 */}
      <Valve
        tag="GLV_8"
        x={416}
        y={608}
        r={270}
        scale={0.7}
        isClosed={valves.GLV_8}
        toggle={toggleValve}
        className="GLV-8"
      />
      <Indicator
        x={1085}
        y={171}
        isClosed={valves.GLV_8}
      />


      {/* GLV-9 */}
      <Valve
        tag="GLV_9"
        x={436}
        y={635}
        r={90}
        scale={0.7}
        isClosed={valves.GLV_9}
        toggle={toggleValve}
        className="GLV-9"
      />
      <Indicator
        x={1085}
        y={215}
        isClosed={valves.GLV_9}
      />


      <Transmitter
          tag="PT-10203"
          value={pt10203Value}
          x={500}
          y={633}
          unit="MPa"
          max={70}
          HH={60}
          H={55}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS AT THE PARKER ZONE OF NK-2"
        />

        <Transmitter
          tag="TT-10201"
          value={tt10201Value}
          x={576}
          y={633}
          unit="°C"
          max={250}
          HH={225}
          H={200}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS AT THE PARKER ZONE OF NK-2"
        />

        <Transmitter
          tag="PT10204"
          value={pt10204Value}
          isClose={valves.DHSV_10201}
          toggle={toggleValve}
          x={499}
          y={525}
          unit="MPa"
          max={70}
          HH={60}
          H={55}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS AT THE PRODUCTION CASING ABOVE THE DOWNHOLE SAFETY VALVE OF NK-2"
        />

        <Transmitter
          tag="PT102013"
          value={pt102013Value}
          isClose={valves.DHSV_10201}
          toggle={toggleValve}
          x={484}
          y={451.5}
          unit="MPa"
          max={25}
          HH={20}
          H={18}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS AT THE PRODUCTION CASING BELOW THE NK-2 WELLHEAD"
        />

        <Transmitter
          value={tt10202Value}
          x={560}
          y={452}
          unit="°C"
          max={250}
          HH={225}
          H={200}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS AT THE PRODUCTION CASING BELOW THE NK-2 WELLHEAD"
        />

        <Transmitter
          tag="PT-10205"
          value={pt10205Value}
          isClose={valves.DHSV_10201}
          toggle={toggleValve}
          x={410}
          y={188}
          unit="MPa"
          max={25}
          HH={18}
          H={16}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS FLUID FROM NK-2 WELLHEAD TREE CAP"
        />

        <Transmitter
          tag="TT-10205"
          value={tt10205Value}
          x={409}
          y={199}
          unit="°C"
          max={250}
          HH={225}
          H={200}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS FLUID FROM NK-2 WELLHEAD TREE CAP"
        />

        <Transmitter
          tag="PT-10206"
          value={pt10206Target}
          controllingValveOpen={pt10205Value}
          toggle={toggleValve}
          x={668}
          y={308}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS FLUID FROM NK-2 WELLHEAD TO TEST HEADER OR PRODUCTION HEADER"
        />

        <Transmitter
          tag="TT-10206"
          value={tt10206Target}
          controllingValveOpen={tt10205Value}
          toggle={toggleValve}
          x={665}
          y={319}
          unit="°C"
          max={150}
          HH={145}
          H={140}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS FLUID FROM NK-2 WELLHEAD TO TEST HEADER OR PRODUCTION HEADER"
        />

        <Transmitter
          tag="FIQ-10201"
          value={fiqNK2.toFixed(2)}
          toggle={toggleValve}
          x={830}
          y={390}
          unit="BOE"
          max={50000}
          HH={38000}
          H={25000}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE TOTALIZER OF OIL AND GAS FROM NK-2 WELLHEAD AFTER THE CHOKE IN BARREL OF OIL EQUIVALENT"
        />

        <Transmitter
          tag="MPTF-10201"
          value={oilRate.toFixed(2)}
          toggle={toggleValve}
          x={755}
          y={298}
          unit="BPM"
          max={50}
          HH={38}
          H={25}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF CRUDE FROM NK-2 WELLHEAD AFTER THE CHOKE"
        />

        <Transmitter
          tag="MPTF-10202"
          value={gasRate.toFixed(2)}
          toggle={toggleValve}
          x={755}
          y={308}
          unit="SCF/S"
          max={150}
          HH={138}
          H={125}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF GAS FROM NK-2 WELLHEAD AFTER THE CHOKE"
        />

        <Transmitter
          tag="MPTF-10203"
          value={impRate.toFixed(2)}
          toggle={toggleValve}
          x={755}
          y={318}
          unit="LPM"
          max={40}
          HH={38}
          H={25}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF SEDIMENT AND WATER FROM NK-2 WELLHEAD AFTER THE CHOKE"
        />

        <button
          onClick={resetFIQ}
          style={{
            position: "absolute",
            left: 895,
            top: 386
          }}
        >
          RESET
        </button>


        <Transmitter
          tag="FIC-10204"
          value={fic10204.toFixed(2)}
          toggle={toggleValve}
          x={965}
          y={298}
          unit="BOE/M"
          max={170}
          HH={168}
          H={150}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF OIL AND GAS FROM NK-2 WELLHEAD TO TEST HEADER"
        />

        <Transmitter
          tag="FIC-10205"
          value={fic10203}
          toggle={toggleValve}
          x={963}
          y={389}
          unit="BOE/M"
          max={170}
          HH={168}
          H={150}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF OIL AND GAS FROM NK-2 WELLHEAD TO PRODUCTION HEADER-1"
        />

        <Transmitter
          tag="PT-10207"
          value={pt10207}
          isClose={valves.XV_10208}
          toggle={toggleValve}
          x={700}
          y={451.5}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF METHANOL FROM METHANOL SUPPLY MANIFOLD"
        />

        <Transmitter
          tag="FIC-10203"
          value={fic10200}
          isClose={valves.XV_10208}
          toggle={toggleValve}
          x={805}
          y={451.5}
          unit="LPM"
          max={20}
          HH={18}
          H={15}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF METHANOL FROM METHANOL SUPPLY MANIFOLD."
        />


        <Transmitter
          tag="PT-10208"
          value={pt10208}
          isClose={valves.XV_10203}
          toggle={toggleValve}
          x={530}
          y={106}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF CORROSION INHIBITOR (WATER-BASED) FROM CORROSION INHIBITOR  MANIFOLD."
        />

        <Transmitter
          tag="FIC-10202"
          value={fic10202}
          isClose={valves.XV_10203}
          toggle={toggleValve}
          x={623}
          y={106}
          unit="LPM"
          max={20}
          HH={18}
          H={15}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF CORROSION INHIBITOR (WATER-BASED) FROM CORROSION INHIBITOR  MANIFOLD."
        />

        <Transmitter
          tag="PT-10209"
          value={pt10209}
          toggle={toggleValve}
          x={293}
          y={452}
          unit="MPa"
          max={35}
          HH={24}
          H={20}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF GAS INJECTION FROM GAS LIFT  MANIFOLD."
        />

        <Transmitter
          tag="FIC-10201"
          value={fic10201}
          toggle={toggleValve}
          x={215}
          y={418}
          unit="SCF/S"
          max={70}
          HH={68}
          H={65}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF GAS INJECTION FROM GAS LIFT  MANIFOLD."
        />

        
        <Transmitter
          tag="PT-10201"
          value={pt10201}
          toggle={toggleValve}
          x={245}
          y={309}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF ASPHALTENE INHIBITOR FROM ASPHALTENE INHIBITOR MANIFOLD."
        />

        <Transmitter
          tag="FIC-10209"
          value={fic10209}
          toggle={toggleValve}
          x={318}
          y={309}
          unit="SCF/S"
          max={20}
          HH={18}
          H={15}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF ASPHALTENE INHIBITOR FROM ASPHALTENE INHIBITOR MANIFOLD."
        />

        


    </div>
  );
}

export default NK2Wellhead;